<template>
  <div class="ui-activity-introduce-wrapper">
    <div class="title">
      <img v-if="titleImg" :src="titleImg" class="img-title tag" />
    </div>
    <div class="content">
      {{ content }}
    </div>
  </div>
</template>

<script>
export default {
  name: "uiActivityIntroduce",
  props: {
    titleImg: {
      type: String,
      default: ""
    },
    content: {
      type: String,
      default: ""
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-activity-introduce-wrapper {
  position: relative;
  background: #ffffff;
  border-radius: 0.2rem;
  padding: 0.4rem 0.2rem 0.3rem;
  .title {
    width: 2.4rem;
    height: 0.6rem;
    position: absolute;
    top: -0.3rem;
    left: 50%;
    transform: translate3d(-50%, 0, 0);
    .img-title {
      height: 100%;
      width: 100%;
    }
  }
}
.ui-activity-introduce-wrapper.pc {
  padding: 46px 28px 40px;
  border-radius: 20px;
  .title {
    width: 208px;
    height: 52px;
    top: -26px;
  }
}
</style>
